import { useEffect, useState } from "react";

const CITY_LIST_URL = "https://pub-9b24add32f5740d88f5d4964aab0dedb.r2.dev/assets/Data/Cities.json";

export const searchHotelCities = (cities, query) => {
    const normalizedQuery = query.trim().toLowerCase();
    const availableCities = cities.filter((city) => city.type !== "MULTI_CITY_VICINITY");
    if (!normalizedQuery) {
        return availableCities.slice(0, 8);
    }

    return availableCities
        .map((city) => {
            const name = city.cityName.toLowerCase();
            const region = city.fullRegionName.toLowerCase();
            const rank = name.startsWith(normalizedQuery) ? 0
                : region.startsWith(normalizedQuery) ? 1
                    : name.includes(normalizedQuery) || region.includes(normalizedQuery) ? 2
                        : -1;
            return { city, rank };
        })
        .filter((result) => result.rank !== -1)
        .sort((a, b) => a.rank - b.rank || a.city.fullRegionName.localeCompare(b.city.fullRegionName))
        .slice(0, 8)
        .map((result) => result.city);
};

const useHotelCities = () => {
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const controller = new AbortController();

        const loadCities = async () => {
            try {
                const response = await fetch(CITY_LIST_URL, { signal: controller.signal });
                if (!response.ok) {
                    throw new Error(`Hotel city list request failed (${response.status})`);
                }

                const data = await response.json();
                if (!Array.isArray(data) || !data.every((city) =>
                    city &&
                    (typeof city.id === "number" || typeof city.id === "string") &&
                    typeof city.cityName === "string" &&
                    typeof city.countryName === "string" &&
                    typeof city.fullRegionName === "string"
                )) {
                    throw new Error("Hotel city list response has an invalid format");
                }

                setCities(data);
                setError("");
            } catch (requestError) {
                if (requestError.name !== "AbortError") {
                    console.error("Failed to load hotel city list", requestError);
                    setError("City suggestions are temporarily unavailable. Please try again shortly.");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        loadCities();
        return () => controller.abort();
    }, []);

    return { cities, loading, error };
};

export default useHotelCities;
